import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteVideo } from "../../api/videos";

export function useDeleteVideo() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: deleteVideo,

    // optional: optimistic update for snappy UI
    onMutate: async (id) => {
      await qc.cancelQueries({ queryKey: ["videos"] });
      const previous = qc.getQueryData(["videos"]);
      qc.setQueryData(["videos"], (old = []) => old.filter((v) => v.id !== id));
      return { previous };
    },
    onError: (_err, _id, ctx) => {
      if (ctx?.previous) qc.setQueryData(["videos"], ctx.previous);
    },
    onSettled: () => {
      qc.invalidateQueries({ queryKey: ["videos"] });
    },
  });
}

export default useDeleteVideo;
